// src/apolloClient.js
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_API_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("jwt");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});


const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(), // Apollo requires a cache instance, but we can bypass it
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache", // ⛔ never use cache for queries
      errorPolicy: "ignore",
    },
    query: {
      fetchPolicy: "no-cache", // ⛔ always get fresh data
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});


export default client;
